import React, { useMemo } from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "antd/es/form";
import { useWatch } from "antd/es/form/Form";
import { defineMessages, useIntl } from "react-intl";

import { SelectField } from "@mapmycustomers/ui";

import RadioGroup from "@app/component/input/RadioGroup";
import { DateRange, getDateRangeDisplayName } from "@app/enum/dashboard/dateRanges";
import {
  ALL_RANGES,
  getDateSubRangeDisplayName,
  NextDateSubRange,
} from "@app/enum/dashboard/nextDateRanges";
import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";

const messages = defineMessages({
  range: {
    id: "dashboard.editModal.dateRange.next.default.range",
    defaultMessage: "Period",
    description:
      "Title of the Range field in a time range form in Edit New Records Modal on Dashboard",
  },
  subRange: {
    id: "dashboard.editModal.dateRange.next.default.subRange",
    defaultMessage: "Display data within",
    description:
      "Title of the Sub Range field in a time form in Edit New Records Modal on Dashboard",
  },
});

interface Props extends CardConfigurationProps {}

const DefaultNextTimeRangeFormComponent: React.FC<Props> = ({ disabled }) => {
  const intl = useIntl();
  const rangeOptions = useMemo(
    () =>
      (Object.keys(ALL_RANGES) as DateRange[]).map((range) => ({
        label: getDateRangeDisplayName(intl, range),
        value: range,
      })),
    [intl]
  );

  const rangeValue: DateRange | undefined = useWatch(["dateRange", "range"]);
  const subRangeOptions = useMemo(
    () =>
      rangeValue
        ? ALL_RANGES[rangeValue].map((subRange) => ({
            label: getDateSubRangeDisplayName(intl, rangeValue, subRange),
            value: subRange,
          }))
        : undefined,
    [intl, rangeValue]
  );

  return (
    <div>
      <Form.Item label={intl.formatMessage(messages.range)} name={["dateRange", "range"]}>
        <SelectField<DateRange>
          disabled={disabled}
          options={rangeOptions}
          showArrow
          suffixIcon={disabled ? <FontAwesomeIcon icon={faLock} /> : undefined}
        />
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.subRange)} name={["dateRange", "subRange"]}>
        <RadioGroup<NextDateSubRange> disabled={disabled} options={subRangeOptions} vertical />
      </Form.Item>
    </div>
  );
};

export default DefaultNextTimeRangeFormComponent;
